const breadCrumb = "Lotação de Servidores - Diretores e Secretários";

const routes = [
  {
    path: "/nomeacao-coordenadores",
    name: "nomeacao-coordenadores",
    meta: {
      allowedPermissions: ["nomeacao_list"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import("@/views/NomeacaodeCoordenadores/NomeacaoDeCoordenadoresHome.vue"),
  },
  {
    path: "/nomeacao-coordenadores/novo",
    name: "nomeacao-coordenadores-novo",
    meta: {
      allowedPermissions: ["nomeacao_insert"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import("@/views/NomeacaodeCoordenadores/NomeacaoDeCoordenadoresCad.vue"),
  },
  {
    path: "/nomeacao-coordenadores/consultar/:id",
    name: "nomeacao-coordenadores-consultar",
    meta: {
      allowedPermissions: ["nomeacao_show"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/NomeacaodeCoordenadores/NomeacaoDeCoordenadoresConsultar.vue"
      ),
  },
  {
    path: "/nomeacao-coordenadores/editar/:id",
    name: "nomeacao-coordenadores-editar",
    meta: {
      allowedPermissions: ["nomeacao_update"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import("@/views/NomeacaodeCoordenadores/NomeacaoDeCoordenadoresEdit.vue"),
  },
];

export default routes;
